import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonDecorationMapItem } from '../polygon-decoration-map-item';
import { MeshConstants } from 'src/app/util/mesh-constants';

@RegisterElement()
export class TallTree extends PolygonDecorationMapItem {
    public override TypeName: string = 'TallTree';

    constructor(formGroup: FormGroup) {
        super(formGroup, "TallTree", 'assets/icons/talltree.svg', 3, MeshConstants.talltreesdistance * 1000);

        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
    }

    public override clone(): TallTree {
        return new TallTree(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            }
        ];
    }

    public override default(): TallTree {
        return this;
    }
}
